module.exports = __webpack_public_path__ + "static/media/Icon-CV_Profile.f3c3b600.svg";